import React from "react";
import {Marker} from "react-leaflet";
import {IconLocation} from "./IconLocation";


const Markers = () =>{
    return(
        <div>
            <Marker position={{lat:"-34.597431226239415", lng:"-58.378690138654825" }} icon={IconLocation}/>
            
        </div>
    )
}

export default Markers;